<template>

<div class="pop-pane pop-pane-right">
<transition name="pop-pane">
<div class="cart" v-show="shown">
  <ul>
    <li v-for="(item, ii) in cartItems">
      <span class="subtitle">{{ item?.ticket?.event?.title }}</span>
      <span class="title">{{ item?.ticket?.props?.title }}</span>
      <span class="price">{{ formatPrice(item?.price) }}</span>
      <input type="number" min="1" max="20" v-model="item.qty" />
      <a class="remove" href="" v-on:click.prevent="popItem(ii)">&times;</a>
    </li>
    <li v-if="discountApplied">
      <span class="subtitle">Discount: Code: {{ discountApplied.props.discountCode?.content }}</span>
      <span class="price">- {{ (discountApplied.props.discountAmount?.content*1 || 0).toFixed(2) }} {{ currency || "CHF" }}</span>
    </li>
    <li class="discount-code">
      <input v-if="!discountApplied" type="text" v-model="discount" placeholder="Discount code" />
<!--       <span v-else>Code applied: <em>{{ discountApplied.props.discountCode?.content }}</em> &nbsp;</span> -->
      <a v-if="!discountApplied" href="" class="button" v-on:click.prevent="applyDiscount">Apply</a>
      <a v-else href="" class="button" v-on:click.prevent="applyDiscount">Remove discount</a>
    </li>
  </ul>
  <div class="total" v-if="cartItems && cartItems.length">
    <span class="total-price">{{ formatPrice(totalPrice) }}</span>
    <span class="label">IN TOTAL</span>
    <label class="tc"><input type="checkbox" v-model="agreeTc" />I agree to the <a href="" v-on:click.prevent="showTc">Terms and Conditions</a></label>
    <ul class="currency">
      <li>
        <label>
          <input type="radio" v-model="currency" value="EUR" />
          <span>€</span>
        </label>
      </li>
      <li>
        <label>
          <input type="radio" v-model="currency" value="USD" />
          <span>$</span>
        </label>
      </li>
      <li>
        <label>
          <input type="radio" v-model="currency" value="CHF" />
          <span>CHF</span>
        </label>
      </li>
    </ul>
    <div class="pay-method">
<!--       <label class="total-price">Proceed to payment</label> -->
      <a v-if="agreeTc && !hasPayPal" :href="'/checkout/card?currency='+currency+'&discount='+(discountApplied?.props?.discountCode?.content || '')" class="button">PROCEED TO PAYMENT</a>
      <div class="method-list" v-else-if="agreeTc">
        <a href="/checkout/card" class="button" v-on:click.native="$parent.cartOpen=false">Pay with Card</a>
        <a href="/checkout/paypal" class="button" v-on:click.native="$parent.cartOpen=false">Pay with PayPal</a>
      </div>
      <a v-if="!hasPayPal && !agreeTc" class="button disabled">PROCEED TO PAYMENT</a>
      <div class="method-list" v-else-if="!agreeTc">
        <a class="button disabled" href="" v-on:click.prevent="">Pay with Card</a>
        <a class="button disabled" href="" v-on:click.prevent="">Pay with PayPal</a>
      </div>
    </div>
  </div>
  <div class="empty" v-else>
    <span>(cart empty)</span>
  </div>
</div>
</transition>
</div>

</template>
<script>
import Cookies from 'js-cookie';
import formatters from './formatters';
export default {
  mixins: [formatters],
  data: ()=>({
    cartItems: [],
    agreeTc: false,
    shown: false,
    hasPayPal: false,
    discount: "",
    discountApplied: null,
  }),
  computed: {
    totalPrice() {
      var discount=0;
      if (this.discountApplied && this.discountApplied.props.discountAmount?.content*1)
        discount=this.discountApplied.props.discountAmount?.content*1;
      return this.cartItems.map((a)=>a.price*a.qty).reduce((a,b)=>a*1+b*1, 0)-discount;
    },
  },
  watch: {
    cartItems: {
      handler() {
        var cart=this.cartItems.map(item=>item.id+"*"+item.qty);
        Cookies.set("appcart", cart.join(","), {path: "/"});
      }, deep: true
    },
  },
  methods: {
    applyDiscount() {
      this.discountApplied=(window.appAvailableDiscounts || []).find(item=>item.props.discountCode?.content==this.discount);
      this.discount="";
    },
    showTc() {
      if (window.tcPopup)
        window.tcPopup.tcVisible=true;
    },
    updateCartItems() {
      try {
        var cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { }

      this.cartItems=[];
      for(var itemId of cart) {
        var item=itemId.split("*");
        itemId=item[0];
        var qty=item[1] || 1;
        var ticket=(window.appAvailableTickets || []).find(item=>item.id==itemId);
        this.cartItems.push({
          id: itemId,
          qty: qty,
          ticket: ticket,
          price: ticket?.props?.price,
        });
      }
      this.appCartIcon?.updateCount(this.cartItems.length);
    },
    pushItem(id) {
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { }
      if (cart.indexOf(String(id || ""))!=-1)
        return;
      cart.push(String(id || ""));
      Cookies.set("appcart", cart.join(","), {path: "/"});
//       appNotifications.show("Item added to cart", "success");

      this.updateCartItems();
    },
    popItem(index) {
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { }
      cart.splice(index, 1);
      Cookies.set("appcart", cart.join(","), {path: "/"});
      this.updateCartItems();
    },
  },
  mounted() {
    window.appCart=this;
    this.updateCartItems();
    var that=this;
    $(".buy-ticket").click(function() {
      that.pushItem($(this).attr("data-id"));
      that.shown=true;
    });
  },
}
</script>

